namespace TabAurous.Retail {
    export interface GiftVoucherSalesReceiptForm {
        ModeId: Serenity.LookupEditor;
        LedgerId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        RefNo: Serenity.StringEditor;
        Scheme: Serenity.LookupEditor;
        ChequeNo: Serenity.IntegerEditor;
        ChequeDate: Serenity.DateEditor;
    }

    export class GiftVoucherSalesReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.GiftVoucherSalesReceipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherSalesReceiptForm.init)  {
                GiftVoucherSalesReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;

                Q.initFormType(GiftVoucherSalesReceiptForm, [
                    'ModeId', w0,
                    'LedgerId', w0,
                    'Amount', w1,
                    'RefNo', w2,
                    'Scheme', w0,
                    'ChequeNo', w3,
                    'ChequeDate', w4
                ]);
            }
        }
    }
}
